export default __webpack_public_path__ + "static/media/28.c6749b77.png";